import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../features/auth/authAPI';
import { Link } from 'react-router-dom';
import axios from 'axios';

export function CivicIdBadge() {
    const dispatch = useDispatch();
    const walletAddress = useSelector((state) => state.auth.walletAddress);
    const isCivic = useSelector((state) => state.auth.isCivic);
    const [showCivicModal, setShowCivicModal] = useState(false);
    const [isCivicId, setIsCivicId] = useState('');
    const [civicId, setCivicId] = useState('');

    const handleCivic = () => {
        setShowCivicModal(true);
    };

    const closeModal = async () => {
        setShowCivicModal(false);
        try {
            const response = await axios.get(`https://api.civic.com/identity-store/did:pkh:eip155:1:${walletAddress}`);
            response.data.linkedWallets[0].address && setCivicId(response.data.linkedWallets[0].address);
        } catch (error) {
            try {
                const response = await axios.get(`https://api.civic.com/pass-lookup/${walletAddress}`);
                if (civicId) {
                    (response.data[civicId].passes.IDV[0].state === "ACTIVE" || response.data[civicId].passes.UNIQUENESS[0].state === "ACTIVE") && setIsCivicId("ACTIVE");
                } else {
                    response.data[walletAddress].passes.CAPTCHA[0].state === "ACTIVE" && setIsCivicId("ACTIVE");
                }
            } catch (error) {
                try {
                    const response = await axios.get(`https://api.civic.com/pass-lookup/${civicId}`);
                    if (civicId) {
                        (response.data[civicId].passes.IDV[0].state === "ACTIVE" || response.data[civicId].passes.UNIQUENESS[0].state === "ACTIVE") && setIsCivicId("ACTIVE");
                    } else {
                        response.data[walletAddress].passes.CAPTCHA[0].state === "ACTIVE" && setIsCivicId("ACTIVE");
                    }
                } catch (error) { console.error(error) }
            }
        }
        (isCivicId === "ACTIVE" && isCivic === "INACTIVE") && await dispatch(update({ isCivicId }))
            .unwrap()
            .then(() => {
                console.log('Civic edited successfully');
            })
            .catch((error) => {
                console.error('Error editing Civic:', error.message || error);
            });
    };

    return (
        <>
            <header className="flex flex-wrap gap-10 justify-between items-center px-4 py-3.5 w-full bg-white rounded-lg border border-solid border-stone-300 max-w-[1315px] min-h-[50px] shadow-[0px_5px_25px_rgba(0,0,0,0.05)] max-md:max-w-full">
                <div className="flex items-center self-stretch my-auto">
                    <span className="self-stretch pr-2 my-auto text-sm text-slate-600">
                        Civic ID Pass:
                    </span>
                    <span
                        className={isCivic === "ACTIVE" ? "self-stretch px-2 py-1 my-auto text-xs font-bold text-white whitespace-nowrap bg-green-400 rounded-full" : "self-stretch px-2 py-1 my-auto text-xs font-bold text-white whitespace-nowrap bg-red-400 rounded-full"}
                        role="status"
                    >
                        {isCivic}
                    </span>
                </div>
                <p className="self-stretch my-auto text-sm text-gray-400 min-w-[240px]">
                    Required for borrowers to verify identity
                </p>
            </header>
            {(showCivicModal && isCivic === "INACTIVE") && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-4/5 h-4/5">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-semibold">Civic Verification</h2>
                            <button onClick={closeModal} className="text-gray-600 hover:text-gray-800">
                                ✖
                            </button>
                        </div>
                        <iframe src="https://getpass.civic.com/" className="w-full h-full rounded-lg border-0"></iframe>
                    </div>
                </div>
            )}
            <nav className="flex flex-wrap gap-10 justify-between items-center px-4 py-3.5 pl-0 w-full max-w-[1315px] min-h-[50px] max-md:max-w-full">
                <div className="flex gap-6 items-center my-auto text-base leading-10 text-white max-md:max-w-full">
                    <button
                        className="gap-2 self-stretch px-5 py-px my-auto w-32 bg-green-600 min-h-[40px] rounded-[37px] shadow-[0px_1px_2px_rgba(0,0,0,0.25)] max-md:px-5"
                        aria-label="Get Verified"
                        onClick={isCivic === "INACTIVE" && handleCivic}
                    >
                        Get Verified
                    </button>
                    <button
                        className="gap-2 self-stretch px-7 py-px my-auto w-32 bg-amber-400 min-h-[40px] rounded-[37px] shadow-[0px_1px_2px_rgba(0,0,0,0.25)] text-slate-900 max-md:px-5"
                        aria-label="See Guide"
                    >
                        <Link to="/guide#guide">See Guide</Link>
                    </button>
                    <button
                        className="gap-2 self-stretch px-6 py-px my-auto bg-blue-600 min-h-[40px] rounded-[37px] shadow-[0px_1px_2px_rgba(0,0,0,0.25)] w-[131px] max-md:px-5"
                        aria-label="Why Lend"
                    >
                        <Link to="/whylend#why-lend">Why Lend</Link>
                    </button>
                </div>
            </nav>
        </>
    );
}